// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IDocCommandInfoArgument {
  name: string;
  description: string;
}
